import * as imageResizer from 'ls-common-client/src/imageResizer';
import config from '../config';

const instance = imageResizer.create(config);

export default instance;
